import i18n from '../../../../i18n';
import { TAB_STATUS } from '../../../../constants';
import { isPointInsideOrgPolygonOrBBox } from '../../../../services/map/boundingBox';
import { getNaturalPersonsFormatted } from '../../../../services/utilities/apis/stuf';
import { getBagVboFeatureInfoFromFilters } from '../../../../services/map/feature/selection';

const store = {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async getNaturalPersons(store, { name, data, title }) {


            // Clear possible results for this title and open new tab with status Loading
            store.dispatch('initTabObjectSearch', { title });

            try {
                let zoomToFeatures = true;
                let pointInsideBbox = true;
                let result;
                let naturalPersons = null;

                // If data has no fields then we are looking for persons without having clicked on an address
                // We create an empty result here.
                if (Object.keys(data).length === 0) {
                    result = {
                        'data': {
                            'aantalVoorkomens': '0',
                            'indicatorVervolgvraag': 'false',
                            'objects': []
                        }
                    };

                } else {
                    // call the API
                    try {
                        // If there are controlDataRecords configured than we loop through all of them and combine the results
                        // The results get an extra column that will contain the name of the Stuf ControlDataRecord (porperty gemeentenaam)

                        result = await store.dispatch('useApiData', { name, data });
                        naturalPersons = getNaturalPersonsFormatted(result.data?.objects, store.state.userIsBrkAuthorized);

                    } catch (error) {
                        // If the error message contains a kadastrale gemeentecode number, replace that
                        // with the toelichting text.
                        const message = error?.data?.response?.data?.message;

                        // Re-throw with custom message
                        throw new Error(message);
                    }
                }


                // persoonlog
                // als naturalPersons.items?.length >0
                // log naturalPersons.item[i] met waarden: BSN, Geslachtsnaam, Voorvoegsel, Voorletters

                if (naturalPersons === null) {
                    naturalPersons = [];
                }
                if (naturalPersons.items?.length > 0) {

                    naturalPersons.items.forEach((person) => {
                        // Log persoon naar avgLog
                        const avgLogData = {
                            Action: 'Stuf',
                            BSN: person.BSN,
                            Naam: person.Geslachtsnaam,
                            Voorletters: person.Voorletters,
                            Voorvoegsel: person.Voorvoegsel
                        };

                        store.dispatch('logAvgUsage', {
                            avgLogData: avgLogData
                        });
                    });
                }

                let featureResults = [];
                // only select/zoom in if 1 person is found (because of technical problem in underlying PDOK BAG WFS service)
                if (naturalPersons.items?.length === 1) {
                    // select feature only when person has postcode and huisnummer
                    if (naturalPersons.items[0].VerblijftInPostcode && naturalPersons.items[0].VerblijftInHuisnummer) {
                        featureResults = await store.dispatch('getFeaturesStuf', { data: naturalPersons });
                        pointInsideBbox = isPointInsideOrgPolygonOrBBox(store.getters.getUserData, featureResults[0].getGeometry());
                        // only zoom to feature if it is inside the bbox
                        zoomToFeatures = pointInsideBbox;
                    } else {
                        store.commit('ADD_STATUS_MESSAGE', {
                            message: i18n.t('errorNaturalPersonNoAddress'),
                            variant: 'info',
                            autoHideDelay: 2000
                        });
                    }
                }
                // Update tab data with search result
                store.commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: naturalPersons,
                    maxResultsExceeded: result.data?.indicatorVervolgvraag === 'true',
                    count: naturalPersons.items?.length,
                    exportable: true,
                    download: true,
                    printable: true,
                    naturalPersons: true,
                    features: featureResults,
                    zoomToFeatures,
                    pointInsideBbox,
                    message: null,
                    status: TAB_STATUS.READY
                });
                store.dispatch('trackUserEvent', { name: 'getNaturalPersons', stage: name });
            } catch (err) {
                // Update tab data with error message
                store.commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: {
                        'items': [],
                        'fields': []
                    },
                    maxResultsExceeded: false,
                    count: 0,
                    status: TAB_STATUS.ERROR,
                    message: `${String(i18n.t('errorStuf'))} ${err.message}`
                });
            }
        },

        async getFeaturesStuf(store, { data }) {
            const items = data.items.map(item => {
                return {
                    postcode: item?.VerblijftInPostcode,
                    huisnummer: item?.VerblijftInHuisnummer,
                    huisletter: item?.VerblijftInHuisletter,
                    toevoeging: item?.VerblijftInHuisnummertoevoeging
                };
            });

            return getBagVboFeatureInfoFromFilters(
                store,
                items
            );
        },

        async highlightNatPersons(store, { item }) {
            // Only get feature when postcode and huisnummer are known
            if (item.VerblijftInPostcode && item.VerblijftInHuisnummer) {
                const data = {
                    highlight: true,
                    zoomToFeatures: true,
                    items: [item]
                };
                const features = await store.dispatch('getFeaturesStuf', { data });
                if (features.length === 1) {
                    store.dispatch(
                        'selectAndZoomToApiResultPointFeatures',
                        {
                            data: {
                                ...data,
                                pointInsideBbox: isPointInsideOrgPolygonOrBBox(store.getters.getUserData, features[0].getGeometry()),
                                features
                            }
                        }
                    );
                }
            } else {
                store.commit('ADD_STATUS_MESSAGE', {
                    message: i18n.t('errorNaturalPersonNoAddress'),
                    variant: 'info',
                    autoHideDelay: 2000
                });
            }
        }
    }
};

export default store;
